module.exports = __webpack_public_path__ + "static/img/anxun43.308d2234.png";